// import { useContext, useState } from 'react';
// import './login-popup.css'
// import { Link } from 'react-router-dom';
// import { cartContext } from '../../App';

// export default function LoginPopUp() {

//     const {showPopup, setShowPopUp} = useContext(cartContext);

//     function handleClose() {
//         setShowPopUp(false);
//     }

//     return (
//         <div className='login-popup-container' style={{ display: `${!showPopup && 'none'}` }}>
//             <div className='login-popup-text-box'>
//                 <p className='login-popup-header'>Enjoy 10% Off in App – Use Code APP10</p>
//                 <p className='login-popup-text'>Download our app now and enjoy exclusive discounts, lightning-fast checkout, and a smoother shopping journey.</p>
//             </div>
//             <div className='popup-cross' onClick={handleClose}><img src='/icons/x-mark.png' alt='X' style={{height:'25px', width:'25px'}}/></div>
//             <div className='login-popup-box'>
//                 <img className='login-popup-logo' src='ic_launcher_rounded.png' alt='logo'/>
//                 <p className='popup-text'>freslo App</p>
//             </div>
//             <Link to='https://play.google.com/store/apps/details?id=com.otu_android' style={{textDecoration: 'none'}}>
//                 <div className='guest-box'>
//                     <img src='google-play-btn.png' alt='play-store' style={{ height: '35px' }} />
//                     <p className='login-popup-download-btn'>DOWNLOAD</p>
//                 </div>
//             </Link>
//         </div>
//     );

// }

import * as Dialog from "@radix-ui/react-dialog";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { cartContext } from "../../App";
import "./login-popup.css";

export default function LoginPopUp() {
  const { showPopup, setShowPopUp } = useContext(cartContext);

  return (
    <Dialog.Root open={showPopup} onOpenChange={setShowPopUp}>
      <Dialog.Portal>
        {/* Overlay */}
        <Dialog.Overlay className="login-popup-overlay" />

        {/* Bottom Popup Content */}
        <Dialog.Content className="login-popup-container">
          {/* Close button */}
          <Dialog.Close asChild>
            <div className="popup-cross">
              <img
                src="/icons/x-mark.png"
                alt="X"
                style={{ height: "25px", width: "25px" }}
              />
            </div>
          </Dialog.Close>

          {/* Your existing content */}
          <div className="login-popup-text-box">
            <p className="login-popup-header">
              Enjoy 10% Off in App – Use Code APP10
            </p>
            <p className="login-popup-text">
              Download our app now and enjoy exclusive discounts,
              lightning-fast checkout, and a smoother shopping journey.
            </p>
          </div>

          <div className="login-popup-box">
            <img
              className="login-popup-logo"
              src="brand-icons/freslo-app-icon.png"
              alt="logo"
            />
            <p className="popup-text">freslo App</p>
          </div>

          <Link
            to="https://play.google.com/store/apps/details?id=com.otu_android"
            style={{ textDecoration: "none" }}
          >
            <div className="guest-box">
              <img
                src="google-play-btn.png"
                alt="play-store"
                style={{ height: "35px" }}
              />
              <p className="login-popup-download-btn">DOWNLOAD</p>
            </div>
          </Link>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
